export default __webpack_public_path__ + "static/media/check-icon.51f7571b.svg";